export const detectAndSaveGeoPosition = (forcePrompt = false) => {
  return new Promise((resolve) => {
    if (typeof window === "undefined") return resolve(null);

    if (!forcePrompt && localStorage.getItem("geo_position")) {
      return resolve(JSON.parse(localStorage.getItem("geo_position")));
    }

    const fallback = { lat: 40.809947662368856, lng: -73.22082853735371 };

    const save = (pos) => {
      localStorage.setItem("geo_position", JSON.stringify(pos));
      resolve(pos);
    };

    if (forcePrompt && navigator.geolocation) {
      try {
        navigator.geolocation.getCurrentPosition(
          (position) => {
            save({
              lat: position.coords.latitude,
              lng: position.coords.longitude,
            });
          },
          async () => {
            try {
              const res = await fetch(
                "https://ipinfo.io/json?token=7f101929bfa13a"
              );
              const data = await res.json();
              const [lat, lng] = data.loc.split(",");
              save({ lat: parseFloat(lat), lng: parseFloat(lng) });
            } catch {
              save(fallback);
            }
          },
          { enableHighAccuracy: true, timeout: 5000, maximumAge: 0 }
        );
      } catch {
        save(fallback);
      }
    } else {
      // IP-based fallback only (silent)
      fetch("https://ipinfo.io/json?token=7f101929bfa13a")
        .then((r) => r.json())
        .then((data) => {
          const [lat, lng] = data.loc.split(",");
          save({ lat: parseFloat(lat), lng: parseFloat(lng) });
        })
        .catch(() => save(fallback));
    }
  });
};
